let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fSO2i")).then(() => parcelRequire('ay7Tg'));